// Source: app/scripts/services/products.js
Auction.factory('Product', ['$resource', function ($resource) {
  return $resource('/data/rest/products/:id', {}, {
    'withdraw': {
      method: 'POST',
      url: '/data/rest/products/withdraw'
    },
    'history': {
      method: 'GET',
      url: '/data/rest/products/history',
      isArray: true
    },
    'log': {
      method: 'GET',
      url: '/data/rest/products/log',
      isArray: true
    },
    'deletePhotos': {
      method: 'POST',
      url: '/data/rest/products/delete_photos',
      isArray: true
  }
  });
}]);


Auction.factory('ProductSubcategories', ['$rootScope','$filter', 'crudService', 'Nav', function ($rootScope, $filter, crudService, Nav) {
  var publicDataService = crudService('product_subcategories');
  return {
    categoryNavigation: function () {
      return Nav.fetch(publicDataService.query, function (data) {
        var navigation = {
          pages: [],
          pageGroups: []
        };
        Nav.newFetch('GENERAL');
        var categories = {};
        angular.forEach(data, function (sc) {
          categories[sc.category.id] = categories[sc.category.id] || {category: sc.category};
          navigation.pages.push({
            id: sc.id,
            name: 'subcategory',
            label: $filter('mfTranslate')(sc, 'label'),
            url: '/subcategory/' + sc.id + '/products',
            weight: sc.id,
            group: categories[sc.category.id]
          });

        });
        angular.forEach(categories, function (cat) {
          cat = angular.extend(cat, {
            id: cat.category.id,
            name: 'category',
            label: $filter('mfTranslate')(cat.category, 'label'),
            url: '/category/' + cat.category.id + '/products',
            weight: cat.category.id,
            parent: 'user_auctions'
          });
          navigation.pageGroups.push(cat);
        });
        return navigation;
      });
    }
  }
}]);


